export const Name = 'newsletter-subscribe';
export const NewsletterSubscribe = Name;
//# sourceMappingURL=index.js.map